<template>
  <div class="registration-form">
    <panel
      class="content"
      title=""
      v-cloak
      :key="key"
    >
      <template v-slot:body>
        <div class="">
          <input type="hidden" :name="honeypotObject.nameFieldName" v-model="organizer.honeypotNameFieldName" />
          <input type="hidden" :name="honeypotObject.validFromFieldName" v-model="organizer.honeypotValidFromFieldName" />
          <div class="has-margin-b30">
            <control
              name="nameControl"
              type="text"
              v-bind:label="__('Szervezet neve')"
              v-model="organizer.title"
            />
            <div
              class="has-text-danger has-margin-b10"
              v-if="errors.title != null"
            >
              {{ errors.title[0] }}
            </div>
          </div>
          <div class="has-margin-b30">
            <control
              name="addressControl"
              type="text"
              v-bind:label="__('Székhely')"
              v-model="organizer.address"
            />
            <div
              class="has-text-danger has-margin-b10"
              v-if="errors.address"
            >
              {{ errors.address[0] }}
            </div>
          </div>
          <div class="has-margin-b30">
            <control
              name="emailControl"
              type="text"
              v-bind:label="__('Email')"
              v-model="organizer.email"
            />
            <div
              class="has-text-danger has-margin-b10"
              v-if="errors.email != null"
            >
              {{ errors.email[0] }}
            </div>
          </div>
          <div class="has-margin-b30">
            <control
              name="registrationNumberControl"
              type="text"
              v-bind:label="__('Nyílvántartási szám / adószám')"
              v-model="organizer.registrationNumber"
            />
            <div
              class="has-text-danger has-margin-b10"
              v-if="errors.registration_number != null"
            >
              {{ errors.registration_number[0] }}
            </div>
          </div>
        </div>
      </template>
    </panel>

    <panel
      class="content"
      title=""
      v-cloak
      :key="key"
    >
      <template v-slot:body>
        <div class="has-margin-b30">
          <control
            name="pdfControl"
            type="file"
            ref="pdfControl"
            v-bind:filename="organizer.pdfUrl"
            v-bind:label="__('Adatvédelmi nyilatkozat (PDF formátumban)')"
            v-model="organizer.pdfFile"
          />
          <div
            class="has-text-danger has-margin-b10"
            v-if="errors.privacy_policy != null"
          >
            {{ errors.privacy_policy[0] }}
          </div>
        </div>
      </template>
    </panel>

    <panel
      class="content"
      title=""
      v-cloak
      :key="key"
    >
      <template v-slot:body>
        <div class="has-margin-b30">
          <control
            name="merchantControl"
            type="text"
            v-bind:label="__('SimplePay Merchant ID')"
            v-model="organizer.simplepayMerchant"
          />
          <div
            class="has-text-danger has-margin-b10"
            v-if="errors.simplepay_merchant != null"
          >
            {{ errors.simplepay_merchant[0] }}
          </div>
        </div>
        <div class="has-margin-b30">
          <control
            name="secretControl"
            type="text"
            v-bind:label="__('SimplePay Secret kulcs')"
            v-model="organizer.simplepaySecret"
          />
          <div
            class="has-text-danger has-margin-b10"
            v-if="errors.simplepay_secret != null"
          >
            {{ errors.simplepay_secret[0] }}
          </div>
        </div>
      </template>
    </panel>

    <panel class="no-background">
      <template v-slot:body>
        <btn
          class="is-success"
          type="default"
          v-html="__('Regisztráció')"
          v-on:click="save"
        ></btn>
      </template>
    </panel>



    <foot v-cloak>
      Helpme.life Admin v1.0<br />
      &copy; Jemefy Technologies Kft.
    </foot>
  </div>
</template>

<script>
import { Btn, Control, Foot, Panel } from "@teamfurther/cinderblock";
import axios from "axios";
import FileService from "../../admin/services/FileService";
import ApiService from "../../admin/services/ApiService";

export default  {
  components: {
    Btn,
    Control,
    Foot,
    Panel
  },
  props: {
    saveUrl: {
      required: true,
      type: String,
    },
    successUrl: {
      required: true,
      type: String,
    },
    honeypot: {
      required: true,
    },
  },
  data: function () {
    return {
      alerts: [],
      errors: {},
      key: 1,
      honeypotObject: JSON.parse(this.honeypot),
      organizer: {
        title: '',
        address: '',
        registrationNumber: '',
        email: '',
        pdfUrl: '',
        pdfFile: null,
        simplepayMerchant: '',
        simplepaySecret: '',
        honeypotNameFieldName: '',
        honeypotValidFromFieldName: '',
      }
    };
  },
  methods: {
    save: function () {
      const data = {
        title: this.organizer.title,
        email: this.organizer.email,
        address: this.organizer.address,
        registration_number: this.organizer.registrationNumber,
        simplepay_merchant: this.organizer.simplepayMerchant,
        simplepay_secret: this.organizer.simplepaySecret,
        privacy_policy: (new FileService()).convertBase64ToFIle(this.organizer.pdfFile, this.$refs.pdfControl.selectedFilename),
      };

      data[this.honeypotObject.nameFieldName] = this.organizer.honeypotNameFieldName;
      data[this.honeypotObject.validFromFieldName] = this.organizer.honeypotValidFromFieldName;

      const formData = (new ApiService().convertDataToFormData(data));

      axios.post(this.saveUrl, formData).then(response => {
        window.location.replace(this.successUrl);
      }).catch((e) => {
        this.errors = e.response.data.errors;
        this.key++;
      });
    },
  },
  mounted() {
    this.organizer.honeypotValidFromFieldName = this.honeypotObject.encryptedValidFrom;
  }
}
</script>

<style scoped>
  .registration-form {
    margin-top: 50px;
  }

  .no-background {
    background: transparent;
    box-shadow: none;
    border: none;
  }
</style>
